import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from 'core/components/library';
import {
    DataGridPro as DataGrid,
    Literal,
    MultiValue,
    Switch,
    Tag,
    ViewEntity
} from 'core/components';
//import * as hlprs from 'core/helpers';
import * as iconsSelector from 'core/icons';
import { ENTITY_ETIQUETA_MARCA } from '../../../../../../store/entities/constants';
import DetailFormato from 'views/maestros/Etiquetas/Detalle';
import * as enums from '../../../../../../core/enums';
import { statesEntity } from '../../../../../../core/enums';
import * as hlprs from '../../../../../../core/components/helpers';
import * as helpers from '../../../../../../core/helpers';

const cols = (row, entityData) => [
    {
        key: 'nombre',
        title: 'Identificador',
        align: 'left',
        //width: '10%',
        component: row && row.nombre
    },
    {
        key: 'fecha',
        title: 'Verificación',
        align: 'center',
        //width: '8%',
        component: row && helpers.getValueFormatted('datetime-base', row.fecha)
    },
    {
        key: 'resgistro',
        title: 'Registro',
        align: 'center',
        //width: '8%',
        component: row && row.registro
    },
    {
        key: 'variedadVino',
        title: 'Vino',
        align: 'left',
        //width: '22%',
        component: row && row.variedadVino && (
            <Literal text={row.variedadVino.descripcion}>
                <iconsSelector.WineIcon fontSize={'small'} />
            </Literal>
        )
    },
    {
        key: 'envase',
        title: 'Envase',
        align: 'left',
        //width: '22%',
        component: row && row.envase && (
            <Literal text={row.envase.descripcion}>
                <iconsSelector.PackageIcon fontSize={'small'} />
            </Literal>
        )
    },
    {
        key: 'variedad',
        title: 'Variedades',
        align: 'left',
        width: '10%',
        component: row && row.variedades && (
            <Literal text={row.variedades} property='variedad.descripcion'>
                <iconsSelector.VarietyIcon
                    style={{
                        fontSize: 15
                    }}
                />
            </Literal>
        )
    },
    {
        key: 'estado',
        title: 'Estado',
        align: 'center',
        width: '10%',
        component: row && (
            <Tag
                align={'center'}
                size={'small'}
                sx={{
                    color: enums.getItem(statesEntity, row.estado, 'color')
                }}
                Icon={enums.getItem(statesEntity, row.estado, 'icon')}
                value={row.estado}
            />
        )
    }
];

const Etiquetas = props => {
    const { values, editing, adding, handleChange, refresh } = props;

    const entityData = useSelector(
        state => state.entities[ENTITY_ETIQUETA_MARCA]
    );

    return (
        <Grid container spacing={3}>
            <Grid item xs>
                <DataGrid
                    readOnly
                    //title='Etiquetas'
                    name='etiquetas'
                    editing={editing}
                    rows={values.etiquetas ? values.etiquetas : []}
                    cols={(name, row, index) => cols(row, entityData)}
                    onDelete={(name, index) => {
                        handleChange(undefined, name, (index + 1) * -1);
                    }}
                    maxHeight={456}
                >
                    <ViewEntity
                        maxWidth={'xl'}
                        key={ENTITY_ETIQUETA_MARCA}
                        refresh={refresh}
                        entity={entityData}
                        initValue={{
                            regEmbotellado: values.regEmbotellado,
                            explotacion: {
                                id: values.id,
                                bodega: { id: values.bodega.id }
                            }
                        }}
                    >
                        {DetailFormato}
                    </ViewEntity>
                </DataGrid>
            </Grid>
        </Grid>
    );
};

export default Etiquetas;
